import React from 'react'

import { FormGroup } from '@grandvisionhq/forms'
import type { FormSlotType } from '@grandvisionhq/lib-form-slots'

import { DateOfBirth, FirstName, LastName, PhoneNumber } from './controls'

const PersonalDetailsForm: FormSlotType = () => (
  <FormGroup>
    <FirstName />
    <LastName />
    <DateOfBirth />
    <PhoneNumber />
  </FormGroup>
)

export default PersonalDetailsForm
